import {Languages} from '../../../core/enums/languages';
import {EnUsRepository} from './en-us-repository';
import {PtBrRepository} from './pt-br-repository';
import {WcsLabelDto} from './wcs-label-dto';

export class WcsLabelFactory {
  private static makePtBr(): WcsLabelDto {
    return new PtBrRepository().translate();
  }

  private static makeEnUs(): WcsLabelDto {
    return new EnUsRepository().translate();
  }

  static make(language: Languages): WcsLabelDto {
    const languages = {
      [Languages.PT_BR]: WcsLabelFactory.makePtBr(),
      [Languages.EN_US]: WcsLabelFactory.makeEnUs(),
    };

    return languages[language];
  }
}
